// Quién puede ver una publicación. Es un filtro de la app, no un control de acceso:
// las reglas de Firestore permiten a cualquier usuario con sesión leer "posts".
export const isPublicPost = (post) => !post?.audience || post.audience === "public";

export const canViewPost = (post, viewerUid, followingIds = []) => {
  if (isPublicPost(post) || post.uid === viewerUid) return true;
  if (post.audience === "followers") return followingIds.includes(post.uid);
  if (post.audience === "close_friends") {
    return Array.isArray(post.audienceUids) && post.audienceUids.includes(viewerUid);
  }
  return false;
};
